import React from 'react';
import { LibraryContentSmallCard } from 'src/common/components/library/content-card/small';
import { Content } from 'src/common/interfaces/content.interface';
import { WizardContentListCardWrapper, WizardContentListCardWrapperProps } from './wrapper';

interface Props extends WizardContentListCardWrapperProps {
  content: Content;
}

export const WizardContentListLibraryCard = ({ content, onDeleteClick }: Props) => (
  <WizardContentListCardWrapper onDeleteClick={onDeleteClick}>
    <LibraryContentSmallCard content={content} editable={false} metadataClassName='pointer-events-none' />
  </WizardContentListCardWrapper>
);
